<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vs-popup class="holamundo " title="Request To connect" :active.sync="open" @close="cancelRequest">
                <div class="custom-modal">
                    <h5>
                        Account ID: {{ company_data.account_id }}
                    </h5>
                    <h5>
                        Company ID: {{ company_data.id }}
                    </h5>
                    <h5>
                        Company Name: {{ company_data.company_name }}
                    </h5>
                    <button v-if="!forceConnect" class="lint-text">Awaiting confirmation for the login
                        request...</button>
                    <button v-else class="lint-text">Logging in to your account in view mode Sign in? </button>
                </div>
                <div v-if="forceConnect" class=" buttons-container">
                    <vs-button class=" disconnect-button float-right mt-6 " @click="cancelRequest">No</vs-button>
                    <vs-button class="float-right mt-6 unimacs_button" @click="forceConnectOverview">Yes</vs-button>


                </div>
                <vs-button v-else class="float-right mt-6 unimacs_button" @click="cancelRequest">Cancel</vs-button>
            </vs-popup>
        </div>

    </div>
</template>

<script>
import axios from '../../../http/axios';
import router from '../../../router';



export default {
    data() {
        return {
            company_data: null,
            disconnectModal: true,
            forceConnect: false,
            open: false,
        };
    },
    watch: {
        "$store.state.startConnection"(val) {
            this.confirmConnection(val)
        },
    },
    methods: {
        confirmConnection(val) {
            if (val) {
                this.open = false
                window.location.href = "/"
            }
        },

        forceConnectOverview() {
            const company_data = localStorage.company_data ? JSON.parse(localStorage.company_data) : null
            if (!company_data && !localStorage.token) { return false }
            axios
                .put(`/company/overview`, {
                    company: company_data.id
                }, {
                    headers: { Authorization: localStorage.token },
                })
                .then((res) => {
                    if (res.data) {
                        localStorage.setItem("isConnectionStart", true);
                        localStorage.setItem("user_data", JSON.stringify({ ...res.data.token, id: res.data.id, token: res.data.token.token, }));
                        this.updateToken(res.data.token.token);
                        this.$store.commit("SET_ADMIN_CONNECT_SOCKET", true);
                        sessionStorage.removeItem("pageRefreshed");
                        sessionStorage.removeItem("pageForceRefreshed");
                        sessionStorage.setItem("userConfirmedConnection", "true");
                        this.$store.commit("SET_ADMIN_CONNECT", { ...res.data.token, id: res.data.id, token: res.data.token.token, });
                        this.$store.commit("SET_ADMIN_START_CONNECT", true);

                        this.open = false;
                        window.location.href = "/";

                    }
                })
                .catch((err) => {
                    this.$vs.loading.close();
                })
        },

        disconnectForceConnection() {
            const user = localStorage.user ? JSON.parse(localStorage.user) : null
            if (!user) { return false }
            axios
                .put(`/company/overview`, {
                    id: user.id
                }, {
                    headers: { Authorization: localStorage.token },
                })
                .then((res) => {
                    if (res.data) {
                        this.open = false;
                        this.rollbackToken()
                        router.push("/companies");
                    }
                })
                .catch((err) => {
                    this.$vs.loading.close();
                })
        },

        cancelRequest() {
            this.$store.commit("SET_ADMIN_START_CONNECT", false);
            this.$vs.loading({
                type: "corners",
            });
            const user = localStorage.user_data ? JSON.parse(localStorage.user_data) : null
            if (this.forceConnect) {
                this.rollbackToken()
                this.$store.dispatch("disconnectSupportOverView", { id: user.id }).then(() => {
                    this.open = false;
                    this.$vs.loading.close();
                    window.close()
                })
            }
            const company_info = localStorage.company_data ? JSON.parse(localStorage.company_data) : null
            if (!user) { return false }
            this.$store.dispatch("disconnectSupport", { id: user.id, company: company_info.id }).then(() => {
                this.$vs.loading.close();
                window.close()
            })
        },

        updateToken(newToken) {
            const currentToken = localStorage.getItem("token");
            const currentPermissions = localStorage.getItem("permissions");
            const currentSettings = localStorage.getItem("settings");
            const currentUser = localStorage.getItem("user");

            localStorage.setItem("oldToken", currentToken);
            localStorage.setItem("oldSettings", currentSettings);
            localStorage.setItem("oldPermissions", currentPermissions);
            localStorage.setItem("oldUser", currentUser);

            localStorage.setItem("token", newToken);

        },

        rollbackToken() {
            const oldToken = localStorage.getItem("oldToken");
            const oldSettings = localStorage.getItem("oldSettings");
            const oldPermissions = localStorage.getItem("oldPermissions");
            // const oldFeatures = localStorage.getItem("oldFeatures");
            const oldUser = localStorage.getItem("oldUser");

            localStorage.setItem("settings", oldSettings);
            localStorage.setItem("permissions", oldPermissions);
            // localStorage.setItem("features", oldFeatures)
            localStorage.setItem("token", oldToken);
            localStorage.setItem("user", oldUser);

            localStorage.removeItem("oldToken");
            localStorage.removeItem("user_data");
            localStorage.removeItem("company_data");
            localStorage.removeItem("oldSettings");
            localStorage.removeItem("oldPermissions");
            localStorage.removeItem("oldUser");
            // localStorage.removeItem("oldFeatures");

            sessionStorage.clear();
            this.$vs.loading({
                type: "corners",
            });
            setTimeout(() => {
                this.$vs.loading.close();
                window.location.href = "/companies"
            }, 600)

        },
    },
    created() {
        const company_info = localStorage.company_data ? JSON.parse(localStorage.company_data) : null
        this.company_data = company_info;

    },
    mounted() {
        // if (!sessionStorage.getItem("pageRefreshed")) {
        //     // Set a flag in sessionStorage to ensure this only happens once
        //     sessionStorage.setItem("pageRefreshed", "true");
        //     location.reload(); // Refresh the page
        // }
        if (this.$route.params.token === "connection") {
            this.forceConnect = true;
            // this.forceConnectOverview()
        } else {
            this.$store.commit("SET_ADMIN_CONNECT_SOCKET", true);
        }
        this.open = true

    }
}
</script>

<style lang="scss">
.custom-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    .lint-text {
        margin-top: 20px;
        border: none;
        background-color: transparent;
        color: aquamarine;
    }

}

.buttons-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;

    .disconnect-button {
        height: 40px;
        background-color: #e74c3c !important;
        color: white;
        border: none;
        border-radius: 8px;
        padding: 0 20px !important;
        cursor: pointer;
        font-size: 14px;
    }
}
</style>
